import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";

export class CancelInvitationPartner {
    constructor(private repository: PartnerSocketRepository) {}
	execute(params: CancelInvitationPartnerParams): Promise<void> {
		return this.repository.cancelInvitationPartner(params.user_id);
	}
}

export class CancelInvitationPartnerParams {
	constructor(public user_id: string) {}
}

